import React, { useState, useEffect } from "react";
import { Row, Col, Container, Table } from "react-bootstrap";
import Sidebar from "../Sidebar";
import { SERVER_PATH } from "../../config/env";
import { Breadcrumbs } from "./../Breadcrumb/index";
import apiClient from "../../utils/api";

export default function UserDetails() {
  // const [selectOption, setSelectOption] = useState("select");
  const [userData, setUserData] = useState([]);

  const userFetchData = async () => {
    await apiClient
      .post(`get/user.php`, {})
      .then((res) => {
        setUserData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    userFetchData();
  }, []);

  return (
    <>
      <Container fluid>
        <Row>
          <Sidebar />
          <Col lg={10} style={{ backgroundColor: "#f1f2f3" }} className="pt-3">
            <Breadcrumbs currentPathName="User Details" />
            {/* <Row>
              <Col className="orderFilterDiv mt-4">
                <Row>
                  <Col
                    lg={4}
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "120px" }}>
                    <div>
                      <label>search by filter</label>
                      <select
                        className="form-select"
                        name=""
                        id=""
                        onChange={(e) => {
                          const selectedOption = e.target.value;
                          setSelectOption(selectedOption);
                        }}>
                        <option value="select">Select any one</option>
                        <option value="user_id">user id</option>
                        <option value="user_name">username</option>
                      </select>
                    </div>
                  </Col>
                  <Col lg={6}>
                    {selectOption === "user_id" ? (
                      <div
                        className="d-flex align-items-center"
                        style={{ height: "120px" }}>
                        <div>
                          <label>Search by User ID</label>
                          <input
                            type="number"
                            placeholder="ENTER USER ID"
                            className="px-2 py-1"
                          />
                          &nbsp;
                          <button
                            className="btn btn-outline-primary text-uppercase"
                            style={{ marginTop: "-5px" }}>
                            submit
                          </button>
                        </div>
                      </div>
                    ) : selectOption === "user_name" ? (
                      <div
                        className="d-flex align-items-center"
                        style={{ height: "120px" }}>
                        <div>
                          <label>Search by User name</label>
                          <input
                            type="text"
                            placeholder="ENTER USERNAME"
                            className="px-2 py-1"
                          />
                          &nbsp;
                          <button
                            className="btn btn-outline-primary text-uppercase"
                            style={{ marginTop: "-5px" }}>
                            submit
                          </button>
                        </div>
                      </div>
                    ) : null}
                  </Col>
                </Row>
              </Col>
            </Row> */}
            <Row className="px-2 my-3">
              <Col className="orderTableDiv">
                <Table borderless responsive className="bg-light">
                  <thead
                    style={{
                      backgroundColor: "#0984e3",
                      color: "#fff",
                      fontSize: ".7em",
                    }}
                  >
                    <tr className="equalWidth">
                      <th>Sno</th>
                      <th>User ID</th>
                      <th>User name</th>
                      <th>Mobile No</th>
                      <th>Address</th>
                      <th>No of Purchase</th>
                      <th>Total Cost of Purchase( &#8377; )</th>
                      <th>Registered Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userData.map((data, index) => {
                      return (
                        <tr className="equalWidth" key={index}>
                          <td>{index+1}</td>
                          <td>{data?.user_id}</td>
                          <td>{data?.user_name}</td>
                          <td>{data?.mobile_no}</td>
                          <td className="overflow-x">
                            {data.user_name},<br />
                            {data?.address}
                          </td>
                          <td>{data?.no_purchases}</td>
                          <td>{data?.total_costof_purchases}</td>
                          <td>{data?.registered_date}</td>
                          <td>
                            {data?.status === 0 ? (
                              <span className="badge bg-secondary">
                                INACTIVE
                              </span>
                            ) : (
                              <span className="badge bg-secondary">ACTIVE</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}
